/**
 * Detects failed dynamic import / stale deploy chunk errors.
 * Boundary reset cannot recover these — a full reload is required.
 */
export const isChunkLoadError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") {
    return false;
  }

  const message =
    "message" in error && typeof (error as { message?: unknown }).message === "string"
      ? (error as { message: string }).message
      : "";
  const name =
    "name" in error && typeof (error as { name?: unknown }).name === "string"
      ? (error as { name: string }).name
      : "";

  const haystack = `${name} ${message}`.toLowerCase();

  return (
    haystack.includes("chunkloaderror") ||
    haystack.includes("loading chunk") ||
    haystack.includes("failed to fetch dynamically imported module") ||
    haystack.includes("error loading dynamically imported module") ||
    haystack.includes("importing a module script failed")
  );
};
